var headerGlobalJs = (function () {
  return {
    init: init,
  };
  function init() {
    var headerHabitat = document.querySelector('.header-habitat');
    //check header habitat Menu html exists
    if (headerHabitat && headerHabitat.innerHTML.length > 0) {
      uiBindings();
    }

    //sync cookie vwo and rails ab experiment
    window.addEventListener('load', function() {
      var header_3_1_experiment_v3 = getCookieVal("header_3_1_experiment_v3", true),
      header_3_1_exp_vwo = getCookieVal("_vis_opt_exp_713_combi", false);
      if (header_3_1_experiment_v3 && header_3_1_experiment_v3 != header_3_1_exp_vwo) {
        setCookieVal('_vis_opt_exp_713_combi', header_3_1_experiment_v3, 30, false);
      } else if (header_3_1_exp_vwo && header_3_1_experiment_v3 != header_3_1_exp_vwo) {
        setCookieVal('header_3_1_experiment_v3', header_3_1_exp_vwo, 30, true);
      }
    });
  }

  function uiBindings() {
    /**
     * Desktop Menu Hover Effects
     */
    var dropdownToggles = document.querySelectorAll('.bstack-mm-products-nav, .bstack-mm-developers-nav'),
      productFocusList = document.querySelectorAll('.bstack-mm-products-nav, .bstack-mm-developers-nav'),
      productMenuToggle = document.getElementById('products-dd-toggle'),
      productMenuDropdown = document.getElementById('products-dd-menu'),
      developersMenuToggle = document.getElementById('developers-dd-toggle'),
      developersMenuDropdown = document.getElementById('developers-dd-menu'),
      eventHoverFlag = [];

    if (dropdownToggles) {
      for (var i = 0; i < dropdownToggles.length; i++) {
        dropdownToggles[i].addEventListener('mouseover', function() {
          var that = this;
          if (that.firstElementChild.classList.contains('focussed')) {
            return false;
          }
          var activeDropdown = that.firstElementChild.getAttribute('data-target'),
            element = document.getElementById(activeDropdown);
          if (!element.classList.contains('active')) {
            element.classList.add('active');
          }
          if (!that.classList.contains('active')) {
            that.classList.add('active');
          }
        });

        dropdownToggles[i].addEventListener('mouseleave', function() {
          var that = this;
          if (that.firstElementChild.classList.contains('focussed')) {
            return false;
          }
          var activeDropdown = that.firstElementChild.getAttribute('data-target'),
            element = document.getElementById(activeDropdown);
          element.classList.remove('active');
          that.classList.remove('active');
        });
      }
    }

    // product Focus
    for (var j = 0; j < productFocusList.length; j++) {
      productFocusList[j].addEventListener('focusout', function(event) {
        var that = this;
        if (!that.contains(event.relatedTarget)) {
          if (that.classList.contains('bstack-mm-products-nav')) {
            closeDropdown(productMenuDropdown, productMenuToggle);
          } else if (that.classList.contains('bstack-mm-developers-nav')) {
            closeDropdown(developersMenuDropdown, developersMenuToggle);
          }
        }
      });

      productFocusList[j].addEventListener('keydown', function(event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
          var that = this;
          if (that.classList.contains('bstack-mm-products-nav')) {
            closeDropdown(productMenuDropdown, productMenuToggle);
            productMenuToggle.focus();
          } else if (that.classList.contains('bstack-mm-developers-nav')) {
            closeDropdown(developersMenuDropdown, developersMenuToggle);
            developersMenuToggle.focus();
          }
        }
      });

      dropdownToggles[j].addEventListener('mouseover', function() {
        var that = this;
        if (that.classList.contains('bstack-mm-products-nav')) {
          if (!productMenuToggle.classList.contains('focussed')) {
            productMenuToggle.classList.add('is-hover');
            if (!eventHoverFlag.includes(productMenuToggle)) {
              headerTrackingEvents(productMenuToggle, false, 'HoveredOnHeader');
              eventHoverFlag.push(productMenuToggle);
            }
          }
        } else if (that.classList.contains('bstack-mm-developers-nav')) {
          if (!developersMenuToggle.classList.contains('focussed')) {
            developersMenuToggle.classList.add('is-hover');
          }
        }
      });

      dropdownToggles[j].addEventListener('mouseleave', function() {
        var that = this;
        if (that.classList.contains('bstack-mm-products-nav')) {
          productMenuToggle.classList.remove('is-hover');
          
          //reset product tab
          resetProductNavTab(productMenuDropdown);
        } else if (that.classList.contains('bstack-mm-developers-nav')) {
          developersMenuToggle.classList.remove('is-hover');
        }
      });
    }

    // developer
    if (productMenuToggle && productMenuDropdown) {
      productMenuToggle.addEventListener('click', function() {
        var that = this,
          isAlreadyHovered = that.classList.contains('is-hover');

        if (isAlreadyHovered) {
          return false;
        }

        var isAlreadyClosed = closeDropdown(productMenuDropdown, that);
        if (isAlreadyClosed) {
          return false;
        }
        openDropdown(productMenuDropdown, that);
      });

      var tablists = productMenuDropdown.querySelectorAll('[role=tablist]');
      for (var k = 0; k < tablists.length; k++) {
        tabsAutomatic(tablists[k]);
      }

      var productTabHover = document.querySelectorAll('.bstack-mm-sub-nav-tab'),
        tabpanel,
        tab,
        eventFlag = [];
      for (var l = 0; l < productTabHover.length; l++) {
        tab = productTabHover[l];
        tab.addEventListener('mouseover', function() {
          var that = this;
          tabpanel = document.getElementById(that.getAttribute('aria-controls'));
          if (tabpanel && !tabpanel.classList.contains('active')) {
            for (var m = 0; m < productTabHover.length; m++) {
              tabpanel = document.getElementById(productTabHover[m].getAttribute('aria-controls'));
              if (that == productTabHover[m]) {
                productTabHover[m].classList.add('active');
                tabpanel.classList.remove('hide');
                productTabHover[m].setAttribute('aria-selected', 'true');
                productTabHover[m].removeAttribute('tabindex');
                if (!eventFlag[m]) {
                  headerTrackingEvents(this, false, 'HoveredOnHeader');
                  eventFlag[m] = true;
                  eventHoverFlag.push(productMenuToggle);
                }
              } else {
                productTabHover[m].classList.remove('active');
                tabpanel.classList.add('hide');
                productTabHover[m].setAttribute('aria-selected', 'false');
                productTabHover[m].tabIndex = -1;
              }
            }
          }
        });

        tab.addEventListener('mouseleave', function() {
          var that = this;
          tabpanel = document.getElementById(that.getAttribute('aria-controls'));
          if (tabpanel && !this.classList.contains('bstack-mm-sub-nav-tab')) {
            for (var m = 0; m < productTabHover.length; m++) {
              that.classList.remove('active');
              tabpanel.classList.add('hide');
            }
          }
        });
      }
    }

    // developer
    if (developersMenuToggle && developersMenuDropdown) {
      developersMenuToggle.addEventListener('click', function() {
        var that = this,
          isAlreadyHovered = that.classList.contains('is-hover');

        if (isAlreadyHovered) {
          return false;
        }
        var isAlreadyClosed = closeDropdown(developersMenuDropdown, that);
        if (isAlreadyClosed) {
          return false;
        }
        openDropdown(developersMenuDropdown, that);
      });
    }

    /**
     * Instrumentation
     */
    var navLinks = document.querySelectorAll(
      '.bstack-mm-logo, .bstack-mm-link, .bstack-mm-btn, .bstack-mm-sub-nav-tab'
    );
    if (navLinks) {
      for (var idx = 0; idx < navLinks.length; idx++) {
        navLinks[idx].addEventListener('click', function () {
          var that = this;
          if (that.classList.contains("bstack-mm-btn")) {
            headerTrackingEvents(that, false, 'ClickedOnHeader');
          } else {
            headerTrackingEvents(that, true, 'ClickedOnHeader');
          }
        }, false);

        if (navLinks[idx].closest('.bstack-mm-sub-nav-tabpanel')) {
          navLinks[idx].addEventListener('mouseover', function () {
            var that = this;
            if (!eventHoverFlag.includes(that)) {
              headerTrackingEvents(that, false, 'HoveredOnHeader');
              eventHoverFlag.push(that);
            }
          }, false);
        }
      }
    }
  }

  function headerTrackingEvents(that, urlExists, eventName) {
    var pageSlug = window.location.pathname,
      pageSlug = pageSlug.replace(/^\/|\/$/g, ''),
      eventObj = {
        action:
          (that.getAttribute('title') ? that.getAttribute('title') : that.getAttribute('aria-label')) +
          (eventName == "ClickedOnHeader" ? ' Main Navigation': ' Product Dropdown'),
        location: 'Primary Header',
        group: that.getAttribute('title'),
        referrer: document.referrer,
        properties_source: getHeaderProsfromURL(pageSlug),
      };

    if (urlExists) {
      eventObj.properties_destination = getHeaderProsfromURL(that.getAttribute('href'));
    }

    if (popUpCSFOptions.vwoShow) {
      eventObj.source = popUpCSFOptions.source;
    }

    //group updated
    if (that.closest('.bstack-mm-products-nav')) {
      eventObj.group = 'Product';
      if (that.closest('.bstack-mm-sub-nav-tab')) {
        var tabName = that.closest('.bstack-mm-sub-nav-tab').getAttribute("title");
        eventObj.group = 'Product ' + (tabName ? tabName: '');
      }

      window._vis_opt_queue = window._vis_opt_queue || [];

      if (eventObj.action == "Web Testing Main Navigation") {
        window._vis_opt_queue.push(function() {_vis_opt_goal_conversion(208);});
      } else if (eventObj.action == "App Testing Main Navigation") {
        window._vis_opt_queue.push(function() {_vis_opt_goal_conversion(209);});
      }
    } else if (that.closest('.bstack-mm-developers-nav')) {
      eventObj.group = 'Developers';
    }

    if (window.hasOwnProperty("WebEventTracker")) {
      WebEventTracker.logEvent(EDS.webEvents, eventName, eventObj);
    }
  }

  function tabsAutomatic(groupNode) {
    var tablistNode = groupNode,
      firstTab = null,
      lastTab = null,
      tabs = Array.from(tablistNode.querySelectorAll('[role=tab]')),
      tabpanels = [];

    for (var i = 0; i < tabs.length; i += 1) {
      var tab = tabs[i],
        tabpanel = document.getElementById(tab.getAttribute('aria-controls'));

      tab.tabIndex = -1;
      tab.setAttribute('aria-selected', 'false');
      tabpanels.push(tabpanel);

      tab.addEventListener('keydown', tabOnKeydown.bind(this));
      tab.addEventListener('click', tabOnClick.bind(this));

      if (!firstTab) {
        firstTab = tab;
      }
      lastTab = tab;
    }

    setSelectedTab(firstTab, false);

    function setSelectedTab(currentTab, setFocus) {
      if (typeof setFocus !== 'boolean') {
        setFocus = true;
      }
      for (var n = 0; n < tabs.length; n += 1) {
        var tabTemp = tabs[n];
        if (currentTab === tabTemp) {
          tabTemp.setAttribute('aria-selected', 'true');
          tabTemp.removeAttribute('tabindex');
          tabTemp.classList.add('active');
          tabpanels[n].classList.remove('hide');
          if (setFocus) {
            tabTemp.focus();
          }
        } else {
          tabTemp.setAttribute('aria-selected', 'false');
          tabTemp.tabIndex = -1;
          tabTemp.classList.remove('active');
          tabpanels[n].classList.add('hide');
        }
      }
    }

    function setSelectedToPreviousTab(currentTab) {
      var index;

      if (currentTab === firstTab) {
        setSelectedTab(lastTab);
      } else {
        index = tabs.indexOf(currentTab);
        setSelectedTab(tabs[index - 1]);
      }
    }

    function setSelectedToNextTab(currentTab) {
      var index;

      if (currentTab === lastTab) {
        setSelectedTab(firstTab);
      } else {
        index = tabs.indexOf(currentTab);
        setSelectedTab(tabs[index + 1]);
      }
    }

    /* EVENT HANDLERS */
    function tabOnKeydown(event) {
      var tgt = event.currentTarget,
        flag = false;

      switch (event.key) {
        case 'ArrowUp':
          setSelectedToPreviousTab(tgt);
          flag = true;
          break;

        case 'ArrowDown':
          setSelectedToNextTab(tgt);
          flag = true;
          break;

        case 'Home':
          setSelectedTab(firstTab);
          flag = true;
          break;

        case 'End':
          setSelectedTab(lastTab);
          flag = true;
          break;

        default:
          break;
      }

      if (flag) {
        event.stopPropagation();
        event.preventDefault();
      }
    }

    function tabOnClick(event) {
      setSelectedTab(event.currentTarget);
    }
  }

  function openDropdown(dropdownElement, buttonElement) {
    dropdownElement.dataset.isopen = 'true';
    dropdownElement.classList.add('active');
    dropdownElement.parentElement.classList.add('active');
    buttonElement.classList.add('focussed');
    buttonElement.setAttribute('aria-expanded', 'true');

    //reset product tab
    resetProductNavTab(dropdownElement);
  }

  function closeDropdown(dropdownElement, buttonElement) {
    var isDropdownOpen = dropdownElement.dataset.isopen;
    if (!!isDropdownOpen && isDropdownOpen === 'true') {
      dropdownElement.dataset.isopen = 'false';
      dropdownElement.classList.remove('active');
      dropdownElement.parentElement.classList.remove('active');
      buttonElement.classList.remove('focussed');
      buttonElement.setAttribute('aria-expanded', 'false');
      return true;
    }
    return false;
  }

  //reset product nav
  function resetProductNavTab(dropdownElement) {
    if (dropdownElement && dropdownElement.getAttribute("id") == "products-dd-menu") {
      var productTabHover = document.querySelectorAll('.bstack-mm-sub-nav-tab'),
      tabpanel;
      for (var m = 0; m < productTabHover.length; m++) {
        tabpanel = document.getElementById(productTabHover[m].getAttribute('aria-controls'));
        if (m == 0) {
          productTabHover[m].classList.add('active');
          tabpanel.classList.remove('hide');
          productTabHover[m].setAttribute('aria-selected', 'true');
          productTabHover[m].removeAttribute('tabindex');
        } else {
          productTabHover[m].classList.remove('active');
          tabpanel.classList.add('hide');
          productTabHover[m].setAttribute('aria-selected', 'false');
          productTabHover[m].tabIndex = -1;
        }
      }
    }
  }

  function getHeaderProsfromURL(url) {
    var txt = '',
      //regex for check URL with domain name
      regex = new RegExp(
        '^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?'
      );

    //check url has domain name
    if (regex.test(url)) {
      var hostName = url.replace('http://', '').replace('https://', '').replace('www.', '').split(/[/?#]/)[0];

      //check url contain browserstack.com
      if (hostName === 'browserstack.com') {
        url = url.substring(url.indexOf(hostName) + hostName.length + 1, url.length);
      } else {
        url = hostName;
      }
    }

    if (!url || url.length === 0) {
      return '';
    }

    var URLArr = url.replace(/^\/|\/$/g, '').split('/');

    if (URLArr.length >= 2) {
      txt = URLArr[0].replaceAll('-', ' ') + ' ' + URLArr[1].replaceAll('-', ' ') + ' page';
    } else {
      txt = URLArr[0].replaceAll('-', ' ');
    }

    //check homepage
    txt = txt.length == 0 ? 'Home page' : txt;

    return txt;
  }
})();

headerGlobalJs.init();
